import styled from './pedidos.module.css';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import ListaPedidos from '../../components/ListaPedidos';
import { BiPlus } from 'react-icons/bi';
import { Link } from 'react-router-dom';


function Pedidos() {



    return (
        <div className={styled.page}>
            <Menu menu="pedidos" />
            <div className={styled.container}>
                <Header page="Pedidos" />
                <div className={styled.content}>
                    <div className={styled.card}>
                        <div className={styled.cardheader}>
                            <div className={styled.cardtitle}>
                                <a>Pedidos</a>
                                <div className={styled.cardtitleline}></div>
                            </div>

                            {/*<div>
                            <Link to ="/NewPed" className={styled.cardbtnnew}>
                               <BiPlus className={styled.btnplus}/>
                               Novo Pedido
                            </Link>
                            </div>*/}
                        </div>
                        <div className={styled.cardcontent}>
                            <div className={styled.apppedidos}>
                                <div className={styled.apppedidosframe101}>

                                    <div className={styled.applistapedidos}>
                                        <div className={styled.applistapedidos100}>
                                            <div className={styled.applistapedidos99}>
                                                <ListaPedidos />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}


export default Pedidos;